import React, { Component } from 'react';
import 'telstra-ui/resources/telstraui.css';
import 'telstra-ui/resources/themes/pacific.css';
import renderHTML from 'react-render-html';
import { Button } from 'telstra-ui/components/button/Button';
import AppWrapper from '../../app-wrapper';
import Loader from '../../components/loader';
import {
  stripStartingAndEndingPTags,
  getButtonType,
} from '../ssm-homepage/ssm-homepage.actions';
import ViewHeader from '../../components/view-header';
import AccountDetails from './ngm-components/account_details/account_details';
import PlanDetails from './ngm-components/plan-details/plan-details';
import TransitionInformation from '../ffwd-homepage/ffwd-components/transition-information/transition-information';
import RecommendedPlans from '../ffwd-homepage/ffwd-components/recommended_plans/recommended_plans';
import SubmitSection from './ngm-components/submit-section/submit-section';
import FloatingCta from '../../components/floating-cta';
import CustomerQuestion from './ngm-components/customer_question/customer_question';
import { updateLiveChatValues, showHideOldNewHeaderFooter } from '../../app-actions';
import {
  preparePostCallArray,
  prepareDefaultState,
  getRecommendedPlanType,
  prepareRecommendPlanPostCallData,
} from './ngm-homepage.actions';
import { NGM_NO_TEXT, IMAGE_BASE_LINK, WINDOW_START_POSITION } from '../../app-constants';
import InstructionSteps from './ngm-components/instruction-steps/instruction-steps';
import './ngm-homepage.css';

class NGMHomePageView extends Component {
    state = {
      modalIsOpen: false,
      formSubmittedLoader: false,
      formSubmittedLoaderRight: false,
      reviewTermsAndConditions: false,
      customerSelectedOptions: {},
      performanceSelectedOptions: [],
      toggleRecommededPlan: false,
      recommendPlanCalculationInProgress: false,
      suggestedPlanDetails: {},
      totalFutureSpentPerMonth: '',
      totalFutureDataInclusionPerMonth: '',
      recommendedPlanType: '',
      preferredTimeContacted: '',
      searchUsed: NGM_NO_TEXT,
      disabledShowPlanBtn: true,
      showSection: true,
    }
    componentDidMount = () => {
      showHideOldNewHeaderFooter(true);
    }

    componentDidUpdate(prevProps) {
      if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded && this.props.formSubmitted === false) {
        updateLiveChatValues(this.props.authorableContent.liveChat, 'NGM');
        this.updateStateData(prepareDefaultState(this.props.authorableContent.customerQuestionData),
          this.validateShowPlayBtn);
        window.setupNgmClickListener();

        if (this.props.getData.similarPlanCount === 2 || this.props.getData.similarPlanCount === 3) {
          const recommendedPlanType = 'recommendationLite';
          const recommendedPlan = this.props.getData.suggestedPlanDetails[recommendedPlanType];
          this.updateStateData({
            suggestedPlanDetails: recommendedPlan.recommendedPlans,
            totalFutureSpentPerMonth: recommendedPlan.totalFutureSpentPerMonth,
            totalFutureDataInclusionPerMonth: recommendedPlan.totalFutureDataInclusionPerMonth,
            recommendedPlanType,
            toggleRecommededPlan: true,
            showSection: !this.props.getData.similarPlanCount,
          });
        }
      }
    }

    onSubmitSiteSubmitButton = () => {
      this.setState({ formSubmittedLoader: true });
      const { submitNGMCustomerData } = this.props.actions;
      const submitData = preparePostCallArray(this.state, this.props.authorableContent.customerQuestionData);
      submitNGMCustomerData(submitData);
    };

    onSubmitSiteSubmitButtonRight = () => {
      this.setState({ formSubmittedLoaderRight: true });
      const { submitNGMCustomerData } = this.props.actions;
      const submitData = preparePostCallArray(this.state, this.props.authorableContent.customerQuestionData);
      submitNGMCustomerData(submitData);
    };

    onSubmitSiteConfirmButton = () => {
      this.setState({ modalIsOpen: true });
    };

    onCloseDialogBox = () => {
      this.setState({
        modalIsOpen: false,
      });
    }

    onChangedSubmitCheckBox = (event) => {
      this.setState({ reviewTermsAndConditions: event.target.checked });
    };

    onChangeQuestionsCheckBox = (event) => {
      const selectedValue = getButtonType(event.target.value);
      const selectedData = this.state.customerSelectedOptions;
      const selectedName = event.target.name;
      if (selectedData[selectedName] === undefined) {
        selectedData[selectedName] = [];
      }
      if (event.target.checked) {
        selectedData[selectedName].push(selectedValue);
      } else {
        selectedData[selectedName] = selectedData[selectedName].filter(data => data !== selectedValue);
      }
      this.setState({ customerSelectedOptions: selectedData });
    };

    updateStateData = (defaultData, callbackfunction) => {
      this.setState(defaultData, callbackfunction);
    };

    validateShowPlayBtn = () => {
      let disabledShowPlanBtn = false;
      this.state.performanceSelectedOptions.map((options) => {
        const selectedValue = options.split('-')[1];
        if (selectedValue === '0' || selectedValue === '') {
          disabledShowPlanBtn = true;
        }
        return disabledShowPlanBtn;
      });
      this.updateStateData({ disabledShowPlanBtn });
    }

    handleOnselectPerformance = (event) => {
      const previousData = this.state.performanceSelectedOptions;
      const [questionIndex, selectedValue] = event.value.split('-');
      if (previousData[questionIndex] !== `${questionIndex}-${selectedValue}`) {
        previousData[questionIndex] = `${questionIndex}-${selectedValue}`;
        this.setState({
          performanceSelectedOptions: previousData,
          toggleRecommededPlan: false,
        }, this.validateShowPlayBtn());
      }
    };

    handleUpdateRecmdPlan = () => {
      const recommendedPlanType = getRecommendedPlanType(this.state.performanceSelectedOptions);
      const { submitNGMRecommendPlanData } = this.props.actions;
      const submitRecommendPlanData = prepareRecommendPlanPostCallData(recommendedPlanType, this.state.searchUsed);
      submitNGMRecommendPlanData(submitRecommendPlanData);

      this.setState({ recommendPlanCalculationInProgress: true });
      setTimeout(() => {
        const recommendedPlan = this.props.getData.suggestedPlanDetails[recommendedPlanType];
        this.setState({
          suggestedPlanDetails: recommendedPlan.recommendedPlans,
          totalFutureSpentPerMonth: recommendedPlan.totalFutureSpentPerMonth,
          totalFutureDataInclusionPerMonth: recommendedPlan.totalFutureDataInclusionPerMonth,
          recommendedPlanType,
        }, () => {
          this.setState({ toggleRecommededPlan: true, recommendPlanCalculationInProgress: false });
        });
      }, 2000);
    }

    handleOnchangeTextArea = (event) => {
      this.setState({ preferredTimeContacted: event.target.value });
    }

    handleDownloadCSVFile = () => {
      const { downloadCSVFile } = this.props.actions;
      downloadCSVFile();
    }

    render() {
      if (this.props.dataLoaded && this.props.formSubmitted === false && this.props.alreadySubmitted === false) {
        const {
          ngm: {
            criteria1Title,
            criteria1Description,
            criteria2Title,
            criteria2Description,
            criteria3Title,
            criteria3Description,
            benefitHeading,
            topImagePath,
            whatYouNeedHeading,
            step1Text,
            step2Text,
            step3Text,
          },
          confirmDetails: {
            accountNumberText,
            accountNameText,
            abnText,
          },
          benefit15G,
          benefit25G,
          benefit35G,
          benefit1AppleDevices,
          benefit3AppleDevices,
          benefit2AppleDevices,
          benefit1OlderDevices,
          benefit2OlderDevices,
          benefit3OlderDevices,
          recommededPlans,
          recommededPlans: {
            recommededPlanDes5GDevice,
            recommededPlanDesAppleDevice,
            recommededPlanDes12MonthsolderDevice,
            estimatedTotalMonthlyCharges: {
              title,
              tooltip: toolTip,
              monthText: perLabel,
              inclGSTText,
            },
            newEstimatedTotalMonthlyCharges: {
              title: newTitle,
              tooltip: newToolTip,
              monthText: newPerLabel,
              inclGSTText: newPlanInclGSTText,
            },
            gbText,
            totalSpendPerMonth: totalMonthText,
            totalDataInclusion: totalInclusionText,
            searchDropdownText,
            searchClearText,
            showRecommededPlansBtnText,
            updateRecommededPlansBtnText,
          },
          explanationSection,
          customerQuestionData,
          planOverview,
        } = this.props.authorableContent;

        const {
          customerAccountName,
          customerAccountNumber,
          customerAbn,
          excelFileDownloadInProgress,
          getData: {
            criteria,
            totalCurrentDataInclusionPerMonth,
            totalCurrentSpentPerMonth,
            currentPlanDetails,
          },
        } = this.props;

        let initialHeader = {
          heading: criteria1Title,
          description: renderHTML(stripStartingAndEndingPTags(criteria1Description)),
        };
        let recommededPlanDescription = recommededPlanDes5GDevice;

        let benefit1 = benefit15G;
        let benefit2 = benefit25G;
        let benefit3 = benefit35G;

        const instructionStepsData = {
          heading: whatYouNeedHeading,
          steps: [
            step1Text,
            step2Text,
            step3Text,
          ],
        };

        const instructionStepsDataWithoutStep1 = {
          heading: whatYouNeedHeading,
          steps: [
            step2Text,
            step3Text,
          ],
        };

        if (criteria === 'APPLEDEVICE') {
          initialHeader = {
            heading: criteria2Title,
            description: renderHTML(stripStartingAndEndingPTags(criteria2Description)),
          };
          recommededPlanDescription = recommededPlanDesAppleDevice;
          benefit1 = benefit1AppleDevices;
          benefit2 = benefit2AppleDevices;
          benefit3 = benefit3AppleDevices;
        } else if (criteria === '12MONTHSOLDERDEVICE') {
          initialHeader = {
            heading: criteria3Title,
            description: renderHTML(stripStartingAndEndingPTags(criteria3Description)),
          };
          recommededPlanDescription = recommededPlanDes12MonthsolderDevice;
          benefit1 = benefit1OlderDevices;
          benefit2 = benefit2OlderDevices;
          benefit3 = benefit3OlderDevices;
        }

        const estimatedTotalCurrentMonthlyCost = {
          title,
          toolTip,
          perLabel,
          totalCost: parseFloat(totalCurrentSpentPerMonth),
          dataInclusion: totalCurrentDataInclusionPerMonth,
          inclGSTText,
          gbText,
          totalMonthText,
          totalInclusionText,
        };

        const estimatedTotalNewMonthlyCost = {
          title: newTitle,
          toolTip: newToolTip,
          perLabel: newPerLabel,
          totalCost: parseFloat(this.state.totalFutureSpentPerMonth),
          dataInclusion: this.state.totalFutureDataInclusionPerMonth,
          inclGSTText: newPlanInclGSTText,
          gbText,
          totalMonthText,
          totalInclusionText,
          asterisk: '*',
        };

        const submitCta = [
          {
            submitLoader: this.state.formSubmittedLoaderRight,
            blueBorder: true,
            svgIcon: 'icon-system-tick-square',
            text: explanationSection.confirmButton,
            onCtaClick: () => {
              this.onSubmitSiteSubmitButtonRight();
            },
          },
        ];

        return (
          <AppWrapper>
            <div className="ngm-homepage root-container container ffwd-homepage body18">
              <AccountDetails
                accountNumberText={accountNumberText}
                accountNameText={accountNameText}
                abnText={abnText}
                customerAccountName={customerAccountName}
                customerAccountNumber={customerAccountNumber}
                customerAbn={customerAbn}
              />
              <div className="row">
                <div className={`${(topImagePath !== undefined && topImagePath !== '') ? 'col-lg-6' : 'col-lg-12'} col-sm-12`}>
                  <ViewHeader content={initialHeader} customOverrideClass="heading40" />
                </div>
                {topImagePath !== undefined && topImagePath !== '' &&
                <div className="col-lg-6 col-sm-12 pl-sm-0 pr-sm-0 header-right-img text-center">
                  <img alt={topImagePath} width="100%" src={`${IMAGE_BASE_LINK}/${topImagePath}`} />
                </div>
                }
              </div>
              {this.state.showSection &&
                <InstructionSteps
                  steps={instructionStepsData}
                />
              }
              {this.state.showSection === false &&
                <InstructionSteps
                  steps={instructionStepsDataWithoutStep1}
                />
              }

              {this.state.showSection &&
                <React.Fragment>
                  <CustomerQuestion
                    customerQuestionData={customerQuestionData}
                    handleOnClickQuestion={this.onChangeQuestionsCheckBox}
                    handleOnselectPrfm={this.handleOnselectPerformance}
                    performanceSelectedOptions={this.state.performanceSelectedOptions}
                  />
                  <div className="plan-hide-show-btn-section padding-top-bottom-24 row text-center-mobile">
                    <div className="col-12 pl-sm-0 pr-sm-0">
                      <Button
                        variant="super"
                        disabled={this.state.disabledShowPlanBtn}
                        onClick={this.handleUpdateRecmdPlan}
                        state={this.state.recommendPlanCalculationInProgress ? 'loading' : 'app'}
                      >
                        {this.state.toggleRecommededPlan ? updateRecommededPlansBtnText : showRecommededPlansBtnText}
                      </Button>
                    </div>
                  </div>
                </React.Fragment>
              }
              <FloatingCta ctas={submitCta} />

              {this.state.toggleRecommededPlan &&
                <React.Fragment>
                  <RecommendedPlans
                    recommededPlans={recommededPlans}
                    recommededPlanDescription={recommededPlanDescription}
                    planDetails={currentPlanDetails}
                    suggestedPlanDetails={this.state.suggestedPlanDetails}
                    estimatedTotalCurrentMonthlyCost={estimatedTotalCurrentMonthlyCost}
                    estimatedTotalNewMonthlyCost={estimatedTotalNewMonthlyCost}
                    numberSearchDropdown
                    searchDropdownText={searchDropdownText}
                    searchClearText={searchClearText}
                    customHeadingClass="heading34"
                    recommendationBanner={this.state.showSection}
                    recommendationTier={this.state.recommendedPlanType}
                    setSearchUsedValue={this.updateStateData}
                    handleDownloadCSVFile={this.handleDownloadCSVFile}
                    excelFileDownloadInProgress={excelFileDownloadInProgress}
                  />
                  <PlanDetails
                    planOverview={planOverview}
                    customHeadingClass="heading34"
                  />
                  <TransitionInformation
                    title={benefitHeading}
                    benefit1={benefit1}
                    benefit2={benefit2}
                    benefit3={benefit3}
                    customHeadingClass="heading34"
                    customSubHeadingClass="heading20"
                  />

                  <SubmitSection
                    authorableContent={explanationSection}
                    onSubmitSiteConfirmButton={this.onSubmitSiteSubmitButton}
                    submitLoader={this.state.formSubmittedLoader}
                    preferredTimeContacted={this.state.preferredTimeContacted}
                    handleOnchangeTextArea={this.handleOnchangeTextArea}
                  />
                </React.Fragment>
              }
            </div>
          </AppWrapper>
        );
      } else if (this.props.dataLoaded && this.props.formSubmitted) {
        const {
          confirmation: {
            heading,
            description,
          },
          confirmDetails: {
            accountNumberText,
            accountNameText,
            abnText,
          },
        } = this.props.authorableContent;
        const {
          customerAccountName,
          customerAccountNumber,
          customerAbn,
        } = this.props;
        const headingWithReferenceNumber = `${heading}`;
        const confirmationHeader = {
          heading: headingWithReferenceNumber,
          description: renderHTML(stripStartingAndEndingPTags(description)),
        };
        window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
        return (
          <AppWrapper>
            <div className="ngm-homepage root-container container ffwd-homepage body18">
              <AccountDetails
                accountNumberText={accountNumberText}
                accountNameText={accountNameText}
                abnText={abnText}
                customerAccountName={customerAccountName}
                customerAccountNumber={customerAccountNumber}
                customerAbn={customerAbn}
              />
              <ViewHeader content={confirmationHeader} customOverrideClass="heading40" />
            </div>
          </AppWrapper>
        );
      } else if (this.props.dataLoaded && this.props.alreadySubmitted) {
        const {
          ngm: {
            alreadySubmittedHeading,
            alreadySubmittedDescription,
          },
          confirmDetails: {
            accountNumberText,
            accountNameText,
            abnText,
          },
        } = this.props.authorableContent;
        const {
          customerAccountName,
          customerAccountNumber,
          customerAbn,
        } = this.props;

        const alreadySubmissionHeader = {
          heading: alreadySubmittedHeading,
          description: renderHTML(stripStartingAndEndingPTags(alreadySubmittedDescription)),
        };
        return (
          <AppWrapper>
            <div className="ngm-homepage root-container container ffwd-homepage already-submitted-page body18">
              <AccountDetails
                accountNumberText={accountNumberText}
                accountNameText={accountNameText}
                abnText={abnText}
                customerAccountName={customerAccountName}
                customerAccountNumber={customerAccountNumber}
                customerAbn={customerAbn}
              />
              <ViewHeader content={alreadySubmissionHeader} customOverrideClass="heading40" />
            </div>
          </AppWrapper>
        );
      }
      return <Loader />;
    }
}


export default NGMHomePageView;
